import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { FaFileContract } from 'react-icons/fa';
import './TermsAndConditions.css';
import BackToHome from '../components/BackToHome';

const TermsAndConditions = () => {
  return (
    <Container className="py-5">
      <BackToHome />
      <Card>
        <Card.Header className="terms-header">
          <h2 className="mb-0">
            <FaFileContract className="me-2" />
            Terms of Service
          </h2>
        </Card.Header>
        <Card.Body className="terms-body">
          {/* Title */}
          <div className="terms-title">
            <h3>📜 Terms of Service</h3>
            <p className="intro-text">
              By using FarmX, you agree to the following terms:
            </p>
          </div>

          {/* Section 1: Platform Nature */}
          <div className="terms-section">
            <h4 className="section-title">1. Platform Nature</h4>
            <p>
              FarmX is a classified marketplace platform only. We do not buy, sell, or verify animals. All transactions are between buyers and sellers.
            </p>
          </div>

          {/* Section 2: User Responsibilities */}
          <div className="terms-section">
            <h4 className="section-title">2. User Responsibilities</h4>
            <p className="subtitle">Users must:</p>
            <ul className="bullet-list">
              <li>Provide accurate information in ads</li>
              <li>Post only legal and ethical listings</li>
              <li>Avoid duplicate or misleading ads</li>
              <li>Respect other users</li>
            </ul>
          </div>

          {/* Section 3: Prohibited Content */}
          <div className="terms-section">
            <h4 className="section-title">3. Prohibited Content</h4>
            <p className="subtitle">The following are not allowed:</p>
            <ul className="bullet-list">
              <li>Illegal animal trade</li>
              <li>Fake, misleading, or spam ads</li>
              <li>Offensive or abusive content</li>
              <li>Fraudulent activity</li>
            </ul>
            <p>
              FarmX reserves the right to remove such content and suspend accounts.
            </p>
          </div>

          {/* Section 4: Chats & Communication */}
          <div className="terms-section">
            <h4 className="section-title">4. Chats & Communication</h4>
            <ul className="bullet-list">
              <li>Chat is provided for buyer–seller communication</li>
              <li>Users are responsible for messages they send</li>
              <li>FarmX is not responsible for disputes</li>
            </ul>
          </div>

          {/* Section 5: Account Suspension */}
          <div className="terms-section">
            <h4 className="section-title">5. Account Suspension</h4>
            <p className="subtitle">FarmX may suspend or terminate accounts if:</p>
            <ul className="bullet-list">
              <li>Terms are violated</li>
              <li>Fraudulent behavior is detected</li>
              <li>Abuse or misuse occurs</li>
            </ul>
          </div>

          {/* Section 6: Liability Disclaimer */}
          <div className="terms-section">
            <h4 className="section-title">6. Liability Disclaimer</h4>
            <p className="subtitle">FarmX is not responsible for:</p>
            <ul className="bullet-list">
              <li>Quality or condition of animals</li>
              <li>Payment disputes</li>
              <li>Losses from transactions</li>
            </ul>
            <p>
              Use FarmX at your own discretion.
            </p>
          </div>

          {/* Section 7: Changes to Terms */}
          <div className="terms-section">
            <h4 className="section-title">7. Changes to Terms</h4>
            <p>
              We may update these terms at any time. Continued use means acceptance of changes.
            </p>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TermsAndConditions;
